import React, {useEffect, useMemo, useRef, useState} from 'react';
import TemplateDefault from "../../components/template-default";
import Card from "../../components/card";
import {useQuery} from "@tanstack/react-query";
import activityControlService from "../../services/activity-control-service";
import {AgGridReact} from "ag-grid-react";
import {LocalizationAgGrid} from "../../utils/localization-ag-grid";
import InputDateTime from "../../components/input-datetime";
import {subDays} from "date-fns";
import {FaEraser} from "react-icons/fa";
import Button from "../../components/button";
import general from "../../utils/general";
import SelectComponent from "../../components/select-component";
import useFetchData from "../requests/hooks/use-fetch-data";
import {toast} from "react-toastify";
import {AlertMessage} from "../../utils/alert-message";
import IconCellRender from "./components/icon-cell-render";
import {useNavigate} from "react-router-dom";
const BASENAME = process.env.PUBLIC_URL;


const initialFilters = {
    init: subDays(new Date(), 10),
    end: new Date(),
    users: []
}
const ActivityFollowUp = () => {
    const navigate = useNavigate();
    const gridRef = useRef();
    const defaultColDef = useMemo(() => ({ resizable: true }), []);
    const [filters, setFilters] = useState(initialFilters);
    const [initialDate, setInitialDate] = useState(subDays(new Date(), 10))
    const [endDate, setEndDate] = useState(new Date())
    const [followUp, setFollowUp] = useState([])
    const {devs} = useFetchData();
    const handleSelect = (name, value) => setFilters(prev => ({...prev, [name]: value}));

    const {isLoading} = useQuery({
        queryFn: async () => {
            const formatedFilters = {
                init: general.formatDate(filters.init, "YYYY-MM-DD"),
                end: general.formatDate(filters.end, "YYYY-MM-DD"),
                users: filters.users.length > 0 ? filters.users.map(u => u.value) : []
            }

            try {
                const {data} = await activityControlService.getFollowUp(formatedFilters);
                const parsedData = JSON.parse(data);

                setFollowUp(parsedData);
                return parsedData;
            } catch (err) {
                console.log(err)
                const message = err?.response?.data?.message;
                toast.error(AlertMessage[message] ?? "Não foi possivel realizar a pesquisa");
                setFollowUp([]);
                return [];
            }
        },
        queryKey: ['follow-up', filters],
        initialData: []
    });

    useEffect(() => {
        if (initialDate && endDate) {
            setFilters(prev => ({...prev, init: initialDate, end: endDate}));
        }
    }, [initialDate, endDate]);

    const clearFields = () => {
        setFilters(initialFilters);
        setInitialDate(subDays(new Date(), 10));
        setEndDate(new Date());
    }

    const columnDefs = useMemo(() => {
        const baseColumns = [
            {
                field: "name",
                headerName: "Usuário",
                flex: 1,
                minWidth: 200,
                onCellClicked: ({value}) => {
                    if (value) navigate(`/activity-control?search=${encodeURIComponent(value)}`);
                }
            }
        ];

        if (!followUp || followUp.length === 0) {
            return [...baseColumns, { field: "total_ok", headerName: "Total", width: 45 }];
        }

        const firstRegister = followUp[0];

        const data = Object.keys(firstRegister).filter(
            key => key !== 'name' && key !== 'total_ok'
        );

        data.sort();

        const colunasDinamicas = data.map(stringData => {
            const [, month, day] = stringData.split('-');
            const formatedHeader = `${day}/${month}`;

            return {
                field: stringData,
                headerName: formatedHeader,
                width: 50,
                cellRenderer: IconCellRender,
                onCellClicked: (params) => {
                    const cellData = typeof params.value === 'string' ? JSON.parse(params.value) : params.value;
                    if (cellData && cellData.id) {
                        window.open(`${BASENAME}/activity-control/form/${cellData.id}`)
                    }
                }
            };
        });

        const finalColumns = [
            { field: "total_ok", headerName: "Total", cellClass: "justify-center", width: 45 }
        ];

        return [...baseColumns, ...colunasDinamicas, ...finalColumns];

    }, [followUp, navigate]);

    return (
        <TemplateDefault title="Acompanhamento" isLoading={isLoading}>
            <Card>
                <div className="flex flex-col lg:grid grid-cols-1 gap-x-6 gap-y-4 lg:grid-cols-12">
                    <div className={"col-span-2"}>
                        <InputDateTime id={"date-init"} name={"init"} label={"Inicio"} selected={initialDate}
                                       onChange={date => setInitialDate(date)}/>
                    </div>
                    <div className={"col-span-2"}>
                        <InputDateTime id={"date-end"} name={"end"} label={"Fim"} selected={endDate}
                                       onChange={date => setEndDate(date)}/>
                    </div>

                    <div className={"flex gap-4 col-span-8"}>
                        <SelectComponent
                            col={"w-full"}
                            instanceId="users"
                            label="Usuários"
                            options={devs ?? []}
                            value={filters.users}
                            onChange={(value) => handleSelect("users", value)}
                            name="users"
                            isMulti
                        />

                        <Button onClick={() => clearFields()}>
                            <FaEraser/>
                        </Button>
                    </div>



                </div>
                <div className={"ag-theme-quartz grid mt-4"} style={{ height: "calc(100vh - 165px)" }}>
                    <AgGridReact
                        ref={gridRef}
                        rowHeight={32}
                        rowData={followUp}
                        columnDefs={columnDefs}
                        defaultColDef={defaultColDef}
                        pagination
                        paginationPageSize={500}
                        paginationPageSizeSelector={[100, 200, 300, 400, 500]}
                        animateRows={false}
                        suppressRowClickSelection={true}
                        suppressCellFocus={true}
                        gridOptions={{ localeText: LocalizationAgGrid }}
                    />
                </div>
            </Card>
        </TemplateDefault>
    );
};

export default ActivityFollowUp;
